import lift, { ArrayOps, ObjectOps, NumberOps, StringOps, DateOps, getValue } from './lift';
export function transform(func) {
    return lift(getValue(func(this.value())));
}
NumberOps.prototype.transform = transform;
StringOps.prototype.transform = transform;
ArrayOps.prototype.transform = transform;
ObjectOps.prototype.transform = transform;
DateOps.prototype.transform = transform;
